import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

import arrow from '../img/arrow.svg';

const Apply = styled.p`
  font-family: Helvetica;
  font-size: 12px;
  padding: 10px 0;
  text-align: ${props => props.navBar ? 'left' : 'center'};
  color: ${props => props.light ? 'white' : '#3B3E4D'};
  span {
    display: none;
  }
  a {
  color: #FF6F43;
  text-decoration: none;
  display: inline-block;
  margin: 5px 0;
  width: ${props => props.navBar ? '100%' : 'auto'};
    &:after {
      content: '';
      display: inline-block;
      vertical-align: middle;
      width: 10px;
      height: 15px;
      margin-left: 5px;
      background: ${props => 'url(' + arrow + ')'} top left no-repeat;
    }
    &:hover {
      text-decoration:underline;
    }
  }
  @media (min-width: ${breakpoints.tablet}) {
    font-size: 17px;
    text-align: center;
    span {
      display: inline-block;
    }
    a {
      width: auto;
      margin: 0;
    }
  }
`;

export default Apply;



// WEBPACK FOOTER //
// ./src/styled-components/Apply.js